import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  laptopWidth,
  MEDIA,
  tabletWidth,
  verticalTabletWidth,
} from 'ylah-shared-resources/lib/styles/_media';

function getMedia() {
  const windowWidth = typeof window !== 'undefined' && window.innerWidth;

  if (windowWidth) {
    if (windowWidth <= verticalTabletWidth) {
      return MEDIA.TABLET_VERTICAL;
    }

    if (windowWidth <= tabletWidth) {
      return MEDIA.TABLET;
    }

    if (windowWidth <= laptopWidth) {
      return MEDIA.LAPTOP;
    }
  }

  return MEDIA.DESKTOP;
}

export default function useMedia() {
  const [media, setMedia] = useState<MEDIA>();

  // useEffect required to avoid hydration error
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMedia(getMedia());
  }, []);

  const onResize = useCallback(() => {
    setMedia(getMedia());
  }, []);

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);

  const isVerticalTablet = useMemo(
    () => !!media && [MEDIA.TABLET_VERTICAL].includes(media),
    [media]
  );

  const isTablet = useMemo(
    () => !!media && [MEDIA.TABLET_VERTICAL, MEDIA.TABLET].includes(media),
    [media]
  );

  const isLaptop = useMemo(
    () =>
      !!media &&
      [MEDIA.TABLET_VERTICAL, MEDIA.TABLET, MEDIA.LAPTOP].includes(media),
    [media]
  );

  return {
    isVerticalTablet,
    isTablet,
    isLaptop,
  };
}
